import { useState } from "react";

export default function InputFile({
    label,
    name,
    accept,
    disabled, 
    required,
    onChange,
    labelRequire=true,
}) {
    /* focus handler - styles css */
    const [isFocused, setIsFocused] = useState(false);
    
    /* error handler - styles css */
    const [isEmpty, setIsEmpty] = useState(false);

    const handleBlur  = (e) => {
        setIsFocused(false);
        setIsEmpty(!!required && !e.target.files?.length);
    };

    const inputFileContent = (
        <div className="inputFile__containerInput">
            <input 
                id={name}
                type="file"
                name={name}
                accept={accept}
                disabled={disabled}
                required={required}
                onChange={onChange}
                onFocus={() => setIsFocused(true)}
                onBlur={handleBlur}
                className="inputFile__containerInput--input"
                style={{ display: "none" }}
            />
        </div>
    );
  return (
        <>
            <div>
                <div className={`inputFile__content ${isFocused ? "inputFile__content--focused" : "" } ${isEmpty ? "inputFile__content--error" : ""}`}>
                    {label ? (
                        <label 
                            htmlFor={name}
                            className={`inputFile__content--label ${isFocused ? "inputFile__content--label--focused" : ""} ${isEmpty ? "inputFile__content--label--error" : ""}`}
                        >
                                {required ? label + '*' : label}
                        </label>
                    ) : null}                        
                    {inputFileContent}                        
                </div>
                {(required && labelRequire) &&(
                    <div className="inputFile__required">
                        <span className={`inputFile__required--textRequired ${isEmpty ? "inputFile__required--textRequired--error" : ""}`}>*Requis</span>
                    </div>
                )}
            </div>
        </>
  )
}
